@if (!!topic || inserting) {
  <section id="topic-detail-component" aria-labelledby="topic-detail-heading">
    @if (editable && topicDraft) {
      <form #topicForm="ngForm" (ngSubmit)="topicForm.valid && save()">
        <header class="topic-header">
          <div>
            <p class="eyebrow">Topic details</p>
            <h2 id="topic-detail-heading">{{inserting ? 'New topic' : 'Edit topic'}}</h2>
          </div>
          @if (CanAdminister() && !inserting) {
            <button type="button" class="topic-button" (click)="cancel()">
              <svg class="cms-icon" aria-hidden="true" focusable="false"><use href="/images/cms-actions.svg#close"></use></svg>
              Cancel
            </button>
          }
        </header>
        <div class="topic-form-grid">
          <div class="form-field full-width">
            <label for="topic-title">Topic</label>
            <textarea id="topic-title" name="topicTitle" [(ngModel)]="topicDraft.topic" rows="2"
              placeholder="Enter a topic for discussion..."></textarea>
          </div>
          <div class="form-field">
            <label for="topic-short-name">Short name</label>
            <input id="topic-short-name" name="shortName" [(ngModel)]="topicDraft.short_name" aria-describedby="short-name-help">
            <p id="short-name-help" class="field-hint">Used to identify this topic in filenames.</p>
          </div>
          <div class="form-field">
            <label for="topic-author">Author</label>
            <input id="topic-author" name="author" [(ngModel)]="topicDraft.author" placeholder="Not specified">
          </div>
          <div class="form-field">
            <label for="topic-min-duration">Minimum recording length (seconds)</label>
            <input id="topic-min-duration" name="minDuration" type="number" inputmode="numeric" min="0" step="1" required
              [(ngModel)]="minimumDuration" aria-describedby="min-duration-help">
            <p id="min-duration-help" class="field-hint" aria-live="polite" aria-atomic="true">{{minimumDuration == null ? 'Enter a duration in seconds.' : durationLabel(minimumDuration)}}</p>
          </div>
          <div class="form-field">
            <label for="topic-max-duration">Maximum recording length (seconds)</label>
            <input id="topic-max-duration" name="maxDuration" type="number" inputmode="numeric" min="0" step="1" required
              [(ngModel)]="maximumDuration" aria-describedby="max-duration-help">
            <p id="max-duration-help" class="field-hint" aria-live="polite" aria-atomic="true">{{maximumDuration == null ? 'Enter a duration in seconds.' : durationLabel(maximumDuration)}}</p>
          </div>
          <div class="form-field">
            @if (programmes.length > 1) {
              <label for="topic-programme">Programme</label>
              <select id="topic-programme" required [(ngModel)]="topicDraft.programme_id" name="programme_id">
                @for (programme of programmes; track programme.id) {
                  <option [ngValue]="programme.id">{{programme.name}}</option>
                }
              </select>
            } @else {
              <span class="field-label">Programme</span>
              <span>{{topicDraft.programme_name || programmes[0]?.name || 'Not specified'}}</span>
            }
          </div>
          <label class="active-field"><input type="checkbox" name="active" [(ngModel)]="topicDraft.active">Active topic</label>
        </div>
        <footer class="form-actions">
          @if (CanAdminister()) {
            <button type="submit" class="topic-button primary" [disabled]="topicForm.invalid">Save topic</button>
          }
        </footer>
      </form>
    } @else {
      <header class="topic-header">
        <div>
          <p class="eyebrow">Topic details</p>
          <h2 id="topic-detail-heading">{{topic.topic}}</h2>
        </div>
        @if (CanAdminister()) {
          <button type="button" class="topic-button" (click)="edit()">
            <svg class="cms-icon" aria-hidden="true" focusable="false"><use href="/images/cms-actions.svg#edit"></use></svg>
            Edit topic
          </button>
        }
      </header>
      <dl class="topic-metadata">
        <div><dt>Short name</dt><dd>{{topic.short_name || 'Not specified'}}</dd></div>
        <div><dt>Programme</dt><dd>{{topic.programme_name || 'Not specified'}}</dd></div>
        <div><dt>Minimum recording length</dt><dd>{{durationLabel(topic.min_duration)}}</dd></div>
        <div><dt>Maximum recording length</dt><dd>{{durationLabel(topic.max_duration)}}</dd></div>
        <div><dt>Author</dt><dd>{{topic.author || 'Not specified'}}</dd></div>
        <div><dt>Status</dt><dd><span class="topic-status" [class.active]="topic.active">{{topic.active ? 'Active' : 'Inactive'}}</span></dd></div>
      </dl>
    }
    @if (saveMessage) { <p class="save-status" role="status">{{saveMessage}}</p> }
  </section>
  @if (topic.response_count > 0) {
    <h2 class="responses-heading">{{topic.response_count}} {{topic.response_count === 1 ? 'response' : 'responses'}}</h2>
  }
} @else {
  <p role="status">Loading topic details...</p>
}
